<template>
  <span>
    <el-popover placement="bottom-start"
                trigger="click" width="500" v-if="selected_list && selected_list.length > 0"
                v-loading="loading" :element-loading-text="loadingText">
			<el-table :data="selected_list" fit :row-style="setRowIndex" :show-header="false">
				<el-table-column property="name" label="名称" width="280">
					<template slot-scope="scope">
						<!-- <span class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                  preview-title-enable="true" preview-nav-enable="true">{{ scope.row.name }}</span> -->
                <span class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                      preview-title-enable="true"
                      preview-nav-enable="true"
                      v-show="!isPdfFile(scope.row.name)">{{scope.row.name}}</span>
                <span class="text-link" @click="previewPdf(scope.row)"
                      v-show="isPdfFile(scope.row.name)" >{{scope.row.name}}</span>
					</template>
				</el-table-column>
				<el-table-column property="size" label="文件大小" width="80">
					<template slot-scope="scope">
						<span>{{ scope.row.size | formatSize }}</span>
					</template>
				</el-table-column>
				<el-table-column property="operation" label="操作" width="90">
				<template slot-scope="scope">
					<el-tooltip effect="light" content="删除" placement="top-start">
						<el-button size="mini" v-if="allowDelete && $perm(['ship.change_ship', 'ship.add_ship'])" type="text"
                       @click="handleDeSelect(scope.row)"><i class="el-icon-delete"></i></el-button>
					</el-tooltip>
					<el-tooltip effect="light" content="下载" placement="top-start">
						<el-button size="mini" type="text" @click="download(scope.row)"><i class="el-icon-download"></i></el-button>
					</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<span class="text-link font-weight-bold" slot="reference">{{ attachment_name }}</span>
		</el-popover>
		<el-tooltip class="item" effect="light" content="打包下载全部文件" placement="top-start">
			<el-button type="text" v-if="selected_list !== undefined && selected_list.length > 0" class="mx-2" v-preventReClick="3000"
                 @click="downloadListByList(object_type, object, selected_list, attachment_name)">
				<i class="el-icon-download"></i>
			</el-button>
		</el-tooltip>
    <el-dialog :title="pdfname" :visible.sync="previewVisible">
          <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
    </el-dialog>
  </span>
</template>

<script>
  import {download, downloadListByList} from '@/utils'
  import {formatSize} from '@/utils/misc'
  import loading from '@/mixins/loading'
  import VuePdfPreview from "@/components/VuePdfPreview"

  export default {
    name: "index",
    components: {
      VuePdfPreview
    },
    mixins: [loading],
    filters: {
      formatSize
    },
    computed: {
      selected_list() {
        let selected_list = this.fileList.filter(file => {
          return file.checked
        })

        return selected_list
      },
      attachment_name() {
        return this.insurance.name + '.zip'
      }
    },
    data() {
      return {
        pdfUrl: '',
        previewVisible:false,
        pdfname: '',
      }
    },
    props: {
      insurance: {
        type: Object
      },
      fileList: {
        type: Array
      },
      allowDelete: {
        type: Boolean,
        default: true
      },
      object: {
      },
      object_type: {
        type: String
      }
    },
    methods: {
      download,
      downloadListByList,
      previewPdf(file){
        // window.open(url, 'PDF', '')
        console.log(file.url)
        this.pdfname = file.name
        this.pdfUrl =  file.url
        this.previewVisible = true
      },
      isPdfFile(filename) {
        var is_pdf = false;
        //获取最后一个.的位置
        var index = filename.lastIndexOf(".");
        //获取后缀
        var ext = filename.substr(index+1);
        //判断是否pdf
        if (['pdf'].indexOf(ext.toLowerCase()) !== -1) {
          is_pdf = true
        }
        return is_pdf
      },
      setRowIndex(params) {
        params.row.index = params.rowIndex
      },
      handleDeSelect(row) {
        this.$set(row, 'checked', false)
        this.$emit('update:fileList', JSON.parse(JSON.stringify(this.fileList)))
      },
    }
  }
</script>
